export default __webpack_public_path__ + "static/media/nounCoin.3210d764.svg";